import { AxiosError } from 'axios'
import toast from 'react-hot-toast'

export function APIErrorMessage(error: AxiosError, showToast: boolean = true): string {
  let message = ''
  if (error.response?.status === 403) {
    
    message = "Don't have permission to perform this action"
  } else if (error.response?.status === 404) {
    const data = error.response?.data as any
    message = `Error occured: ${data?.errors}`
  } else if (error?.response?.data ) {
    const data = error.response?.data as any
    message = data?.detail ?? data?.errors
  } else if ((error?.response?.data as any)?.errors) {
      message = 'Form has errors. Please check highlighted fields'
  } else {
    message = `Something went wrong! please try again later`
  }
  if (showToast) toast.error(message)
  return message
}
